var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAchieveImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.13333,2.13333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98,113l-38,-21l-38,21v-97h76z",
    fill: "#b2abbe",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,109l-38,-21l-38,21v-97h76z",
    fill: "#aa468f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieveImg);
export default __webpack_public_path__ + "static/media/achieveImg.6b14a6c4a786aee5d211e03c091660bd.svg";
export { ForwardRef as ReactComponent };